module.exports = __webpack_public_path__ + "img/attacken-dazwischen-beschwerdefrei.9456e3a0.png";